import { Trans } from 'react-i18next'

import wowFactsPNG from '~/assets/images/art/wow-facts.png'
import wowFactsWEBP from '~/assets/images/art/wow-facts.webp'
import {
  ANSWERS,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

import { Image, Styles as S } from './styles'

const WOW_FACTS_QUESTION = 'Are you interested in this topic?'

const WowFacts = ({ pageId, nextPagePath }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: WOW_FACTS_QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans
              ns="art"
              i18nKey="onboarding.quizBinaryChoice.artQuestionTitle"
            />
          </S.Question>
          <S.CardWrapper>
            <S.Card>
              <S.ImageBackground>
                <picture>
                  <source srcSet={wowFactsWEBP} type="image/webp" />
                  <Image src={wowFactsPNG} alt="WOW Facts" />
                </picture>
              </S.ImageBackground>
              <S.CardTextContent>
                <S.CardTitle>
                  <Trans
                    ns="art"
                    i18nKey="onboarding.quizBinaryChoice.wowFactsTitle"
                  />
                </S.CardTitle>
                <S.CardSubtitle>
                  <Trans
                    ns="art"
                    i18nKey="onboarding.quizBinaryChoice.wowFactsSubtitle"
                    components={{ br: <br /> }}
                  />
                </S.CardSubtitle>
              </S.CardTextContent>
            </S.Card>
          </S.CardWrapper>
        </div>
        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default WowFacts
